import SubscriptionRequest from "@/model/requests/SubscriptionRequest";
import SubscriptionServices from "@/services/SubscriptionServices";
import LoaderUtils from "@/utils/BaseUtils/LoaderUtils";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";

const subscriptionService = new SubscriptionServices();

export const namespaced = true;

export const state = {
  customerSubscriptions: [],
  customerSubscriptionsAlt: [],
  professionalSubscriptions: [],
  subscriptionSuccess: false
};

export const getters = {};

export const mutations = {
  setCustomerSubscriptions: (state, payload) => {
    state.customerSubscriptions = payload;
  },
  setProfessionalSubscriptions: (state, payload) => {
    state.professionalSubscriptions = payload;
  },
  setSubscriptionSuccess: (state, payload) => {
    state.subscriptionSuccess = payload;
  },
  setCustomerSubscriptionsAlt: (state, payload) => {
    state.customerSubscriptionsAlt = payload;
  }
};

export const actions = {
  createSubscription({ commit }, payload = SubscriptionRequest.create) {
    let successAction = () => {
      commit("setSubscriptionSuccess", true);
    };
    return subscriptionService.createSubscription(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readByProfessionalId(
    { commit },
    payload = SubscriptionRequest.readByProfessionalId
  ) {
    let successAction = responseData => {
      commit("setProfessionalSubscriptions", responseData.data);
    };
    return subscriptionService.readByProfessionalSubscription(
      payload,
      successAction,
      LoaderUtils.types.NONE
    );
  },
  readByCustomerId({ commit }, payload = SubscriptionRequest.readByCustomerId) {
    let successAction = responseData => {
      commit("setCustomerSubscriptions", responseData.data);
      commit("setCustomerSubscriptionsAlt", responseData.data);
    };
    return subscriptionService.readByCustomerSubscription(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  approveSubscription({ commit }, payload = SubscriptionRequest.approve) {
    let successAction = () => {
      let subscriptionProfessionalId = StoreUtils.rootGetters(
        "auth/getUserInfo"
      ).professional.professionalId;
      StoreUtils.dispatch("subscription/readByProfessionalId", {
        subscriptionProfessionalId
      });
    };
    return subscriptionService.approveSubscription(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },

  declineSubscription({ commit }, payload = SubscriptionRequest.decline) {
    let successAction = () => {
      let subscriptionProfessionalId = StoreUtils.rootGetters(
        "auth/getUserInfo"
      ).professional.professionalId;
      StoreUtils.dispatch("subscription/readByProfessionalId", {
        subscriptionProfessionalId
      });
    };
    return subscriptionService.declineSubscription(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },

  updateSubscription({ commit }, payload = SubscriptionRequest.update) {
    let successAction = () => {};
    return subscriptionService.updateSubscription(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  }
};
